$(function () {
  var urlParams = new URLSearchParams(location.search);

  var $form = $('#payment_form');
  var $containers = $form.find('.form-field');
  var $fields = $containers.find('input');
  var $textFields = $containers.find('input[type="text"]');
  var $consent = $fields.filter('#consent');
  var $btn = $form.find('[type=submit]');
  
  


  var referencePrefix = '181';
  var referenceLength = Number(11);
  var referenceSuffixLength = referenceLength - referencePrefix.length;

  var referenceRegex = new RegExp('^' + referencePrefix + '[0-9]{' + referenceSuffixLength + '}$');

  var constraints = {
    human: {
      presence: { allowEmpty: false }
    },
    reference: {
      presence: true,
      format: referenceRegex
    },
    amount: {
      presence: true,
      numericality: { greaterThanOrEqualTo: 25.00 }
    }
  };

  if (urlParams.has('error')) {
    populateErrorElements();
  }

  if (urlParams.has('amount')) {
    populateInvoiceElements();
  }

  if ($form.length) {
    initRecaptcha();

    $form.submit(handleSubmit);

    $textFields.val('');
    $textFields.on('change keyup', validateField);

    $consent.on('change', validateConsent);
  }

  window.Payments = {
    recaptchaSuccess: function () {
      $('#human').val('yes').closest('.form-field').addClass('valid');
      updateSubmitBtn();
    },
    recaptchaExpiry: function () {
      $('#human').val('').closest('.form-field').removeClass('valid');
      updateSubmitBtn();
    }
  };

  function initRecaptcha() {
    var script = document.createElement('script');

    script.id = 'container'
    script.src = '//www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;

    script.onload = function () {
      grecaptcha.ready(function () {
        grecaptcha.render('recaptcha', {
          'callback': window.Payments.recaptchaSuccess,
          'expired-callback': window.Payments.recaptchaExpiry,
          'sitekey': '6LfNL9AUAAAAAIpz4sx1ldryr6mJ_imbyizENJYU'
        });
      });
    };

    document.body.appendChild(script);
  }

  function handleSubmit(e) {
    if ($form.hasClass('busy')) {
      return false;
    }

    var errors = validate(e.target, constraints);

    if (errors) {
      return false;
    }

    $form.addClass('busy');
    $btn.val($btn.data('busy-text'));

    return true;
  }

  function validateField(e) {
    var $field = $(this);
    var $container = $field.closest('.form-field');
    var id = $field.attr('id');
    var value = $field.val();

    if (value === '') {
      $container.removeClass('has-error valid');
      return;
    }

    var error = validate.single(value, constraints[id]);

    if (error) {
      $container.addClass('has-error').removeClass('valid');
    } else {
      $container.addClass('valid').removeClass('has-error');
    }

    updateSubmitBtn();
  }
  
   function validateConsent(e) {
    var $field = $(this);
    var $container = $field.closest('.form-field');

    if ($field.is(':checked')) {
      $field.closest('.form-field').addClass('valid');
    } else {
      $field.closest('.form-field').removeClass('valid');
    }

    updateSubmitBtn();
  }

  function updateSubmitBtn() {
    var validCount = $containers.filter('.valid').length;

    if (validCount === $fields.length) {
      $btn.attr('disabled', false);
    } else {
      $btn.attr('disabled', true);
    }
  }

  function populateInvoiceElements() {
    $('#reference').text(urlParams.get('reference'));
    $('#amount').text('$' + urlParams.get('amount'));
    $('#transaction').text(urlParams.get('transaction'));
  }

  function populateErrorElements() {
    $('#reference').text(urlParams.get('reference'));
    $('#code').text(urlParams.get('error'));
    $('#message').text(urlParams.get('message'));
  }
});
